import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import VueAxios from 'vue-axios'

const app = createApp(App);

app.use(store);
app.use(router);
app.use(VueAxios, axios);

import "ant-design-vue/dist/antd.css";

// axios.defaults.withCredentials = true;
app.config.globalProperties.$axios = axios;


app.directive('money', (el, binding) => {
    // this will be called for both `mounted` and `updated`
    el.style.color = 'red'
})


app.directive('money-format', (el, binding) => {
    var c = 2,
        d = ",",
        t = " ",
        s = binding.value < 0 ? "-" : "",
        i = String(parseInt(Math.abs(Number(binding.value) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
    el.innerHTML = s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(binding.value - i).toFixed(c).slice(2) : "");
})

app.directive('number-format', (el, binding) => {
    el.innerHTML = binding.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
})
app.directive('percent-format', (el, binding) => {
    el.innerHTML = binding.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
})


// app.filter('numberFormat', function(n) {
//     return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
// })


// app.filter('cotiPresta', function(cp, a_ty = null, a_ly = null) {
//     var arr = [];
//     cp.filter(function(n) {
//         var c = 2,
//             d = ",",
//             t = " ",
//             s = n < 0 ? "-" : "",
//             i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
//             j = (j = i.length) > 3 ? j % 3 : 0;
//         arr.push(s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : ""));
//     })

//     // if(a_ty != null){
//     //   if((a_ty) < 10 && arr[0] != '0,00'){
//     //     arr[0] = 'NI'
//     //   }
//     // }
//     // if(a_ly != null){
//     //   if((a_ly) < 10 && arr[1] != '0,00'){
//     //     arr[1] = 'NI'
//     //   }
//     // }


//     return '<cp style="color: green">' + arr[0] + ' €</cp><br><cp style="color: olive">' + arr[1] + ' €</cp>'
// })
// app.filter('getRegime', function(r) {
//     if (r == '') return ''

//     var regimes = {
//         'A': 'Régime local',
//         'C': 'Régimes spécifiques',
//         'E': 'Expatriés',
//         'G': 'Régime général',
//         'R': 'Régimes spécifiques',
//         'S': 'Régimes spécifiques',
//         'T': 'TNS'
//     }
//     return regirms[r]
// })

// app.filter('pf', function(n) {
//     return n.replace(/<br>/g, ' ');
// })


const icons = {
    folder: require("@/assets/icons/folder.svg"),
    empty_folder: require("@/assets/icons/empty_folder.svg"),
    params: require("@/assets/icons/params.svg"),
    help: require("@/assets/icons/help.svg"),
    profile: require("@/assets/user.png"),

    home: require("@/assets/icons/menu/home.svg"),
    case: require("@/assets/icons/menu/case.svg"),
    user: require("@/assets/icons/menu/user.svg"),
    save: require("@/assets/icons/menu/save.svg"),
    docs: require("@/assets/icons/menu/docs.svg"),
    email: require("@/assets/icons/menu/email.svg"),
    book: require("@/assets/icons/menu/book.svg"),
}

app.config.globalProperties.$icons = icons;


import {
    Dropdown,
    Checkbox,
    Select,
    Menu,
    Layout,
    Button,
    Spin,
    Result,
    Card,
    Divider,
    Col,
    Row,
    Drawer,
    Table,
    Form,
    InputNumber,
    Tag,
    Switch,
    Input,
    Space,
    Tabs,
    List,
    Avatar,
    Modal,
    Badge,
    Popover,
    Breadcrumb,
    Empty,
    Progress,
    DatePicker,
    Tooltip,
    Slider,
    Affix

} from 'ant-design-vue';

app.use(Dropdown);
app.use(Checkbox);
app.use(Select);
app.use(Menu);
app.use(Layout);
app.use(Button);
app.use(Spin);
app.use(Result);
app.use(Card);
app.use(Divider);
app.use(Col);
app.use(Row);
app.use(Drawer);
app.use(Table);
app.use(Form);
app.use(InputNumber);
app.use(Tag);
app.use(Switch);
app.use(Input);
app.use(Space);
app.use(Tabs);
app.use(List);
app.use(Avatar);
app.use(Modal);
app.use(Badge);
app.use(Popover);
app.use(Breadcrumb);
app.use(Empty);
app.use(Progress);
app.use(DatePicker);
app.use(Tooltip);
app.use(Slider);
app.use(Affix);


app.mount('#app')